var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text--primary"},[_vm._v("High-emphasis has an opacity of 87%.")]),_c('p',{staticClass:"text--secondary"},[_vm._v("Medium-emphasis text and hint text have opacities of 60%.")]),_c('p',{staticClass:"text--disabled"},[_vm._v("Disabled text has an opacity of 37%.")])])
}]

export { render, staticRenderFns }